module.exports = __webpack_public_path__ + "img/about_introduce_icon3@1x.d1854e73.png";